module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/mediumTank-prem-tiny.1f34060a.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/mediumTank-prem-tiny.png
// module id = 2725
// module chunks = 11